import { SDescription } from './styled';

interface IProps {
    description: string,
    isPromo?: boolean,
    className?: string,
}

const Description = ({ description, isPromo = false, className }: IProps): JSX.Element => {
    return (
        <SDescription
            isPromo={isPromo}
            className={className}
            data-test='subitem-desc'
        >
            {description}
        </SDescription>
    );
};

export default Description;
